/* Shared memo status pill — used by both the listings table and the
   drawer header. Kept tiny and prop-driven so it stays a leaf component. */
const STYLES = {
  // Live-computed states
  "Active Memo": "border-[#7BA585]/40 text-[#7BA585] bg-[#7BA585]/[0.07]",
  "Partial Sold": "border-[#D4AF37]/40 text-[#D4AF37] bg-[#D4AF37]/[0.07]",
  "Partial Returned": "border-[#C99356]/40 text-[#C99356] bg-[#C99356]/[0.07]",
  "Partial Paid": "border-[#7BA585]/40 text-[#9DC9A9] bg-[#7BA585]/[0.07]",
  "Overdue": "border-red-500/40 text-red-400 bg-red-500/[0.07]",
  "Completed": "border-[#8A8A8A]/40 text-[#8A8A8A] bg-white/[0.03]",
  "Converted to Sale": "border-[#D4AF37]/40 text-[#D4AF37] bg-[#D4AF37]/[0.07]",
  "Cancelled": "border-red-500/40 text-red-300 bg-red-500/[0.05]",
  // Legacy raw values still seen in older docs
  "On Memo": "border-[#7BA585]/40 text-[#7BA585] bg-[#7BA585]/[0.07]",
  "Returned": "border-[#8A8A8A]/40 text-[#8A8A8A] bg-white/[0.03]",
};

export default function StatusBadge({ status }) {
  return (
    <span
      className={`inline-block px-2 py-1 border text-[0.6rem] uppercase tracking-wider ${STYLES[status] || STYLES["Active Memo"]}`}
      data-testid={`memo-status-${status?.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {status}
    </span>
  );
}
